module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAxElEQVRYR+2Wuw0CMRAF33RAHyQEFAAJOQkt0AJEUAd1kHMUABFUQYJoYJGzk/DpLLSWHdihbb0djT9aVHhQuL4aQH0GzGwlae94N67AcSjvx4CZPSRNHQFC1By4xTJjAIH24AjQSVoD7yQAx8JJUfVdwiRsx03NQH0GzGwiaeZ4zP2oO/DpT8T+gYukRSaADlhWD1D2CDKpH4yt7xU0A82AmXk0JE9JO+A8ZjRnS3YCtv8AeDSlL2AzVjyst3+gGShu4AsG0zQh9F1RNgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 36